/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonRelationA,
  PersonRelationAOptional,
  PersonRelationAMetaI,
  PersonRelationATrackedI,
} from "./person-relation-a";
import {
  PersonRelationATracked,
  PersonRelationAMeta,
} from "./person-relation-a";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonRelationB,
  PersonRelationBOptional,
  PersonRelationBMetaI,
  PersonRelationBTrackedI,
} from "./person-relation-b";
import {
  PersonRelationBTracked,
  PersonRelationBMeta,
} from "./person-relation-b";

/**
 *
 * @export
 * @interface PersonWithRelations
 */
export interface PersonWithRelationsOptional {
  /**
   *
   * @type {Array<PersonRelationA>}
   * @memberof PersonWithRelations
   */
  relationsA?: PersonRelationAOptional[];
  /**
   *
   * @type {Array<PersonRelationB>}
   * @memberof PersonWithRelations
   */
  relationsB?: PersonRelationBOptional[];
}

export interface PersonWithRelations extends PersonWithRelationsOptional {
  /**
   *
   * @type {Array<PersonRelationA>}
   * @memberof PersonWithRelations
   */
  relationsA?: PersonRelationA[];
  /**
   *
   * @type {Array<PersonRelationB>}
   * @memberof PersonWithRelations
   */
  relationsB?: PersonRelationB[];
}

export interface PersonWithRelationsTrackedI {
  /**
   *
   * @type {Array<PersonRelationA>}
   * @memberof PersonWithRelations
   */
  relationsA?: PersonRelationATrackedI[];
  relationsAIsSet: boolean;
  /**
   *
   * @type {Array<PersonRelationB>}
   * @memberof PersonWithRelations
   */
  relationsB?: PersonRelationBTrackedI[];
  relationsBIsSet: boolean;
}

transformDatesMap.set(
  "PersonWithRelations",
  function (model: PersonWithRelations) {
    const transformDatesrelationsA = transformDatesMap.get("PersonRelationA");
    if (transformDatesrelationsA) {
      model.relationsA?.forEach((sub) => {
        transformDatesrelationsA(sub);
      });
    }
    const transformDatesrelationsB = transformDatesMap.get("PersonRelationB");
    if (transformDatesrelationsB) {
      model.relationsB?.forEach((sub) => {
        transformDatesrelationsB(sub);
      });
    }
  },
);

export type PersonWithRelationsMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  relationsA: PropertyMeta<PersonRelationAMetaI>;
  //isDate: false
  //isDatetime: false
  relationsB: PropertyMeta<PersonRelationBMetaI>;
}>;

export var PersonWithRelationsMeta: PersonWithRelationsMetaI =
  {} as PersonWithRelationsMetaI;
PersonWithRelationsMeta = typeMeta("PersonWithRelations", {
  relationsA: propertyMeta(
    "relationsA",
    true,
    false,
    false,
    PersonRelationAMeta,
  ),
  relationsB: propertyMeta(
    "relationsB",
    true,
    false,
    false,
    PersonRelationBMeta,
  ),
});

const metaI = PersonWithRelationsMeta;

registerMeta(() => {});

export class PersonWithRelationsTracked implements PersonWithRelationsTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  relationsA__I?: PersonRelationATracked[] = undefined;
  relationsAIsSet: boolean = false;
  set relationsA(v: undefined | PersonRelationATracked[]) {
    if (v !== undefined) {
      this.relationsA__I = v;
      this.relationsAIsSet = true;
    } else {
      this.relationsA__I = v || undefined;
      this.relationsAIsSet = false;
    }
    this.changeTracker = true;
  }
  get relationsA() {
    return this.relationsA__I;
  }
  relationsB__I?: PersonRelationBTracked[] = undefined;
  relationsBIsSet: boolean = false;
  set relationsB(v: undefined | PersonRelationBTracked[]) {
    if (v !== undefined) {
      this.relationsB__I = v;
      this.relationsBIsSet = true;
    } else {
      this.relationsB__I = v || undefined;
      this.relationsBIsSet = false;
    }
    this.changeTracker = true;
  }
  get relationsB() {
    return this.relationsB__I;
  }
  constructor(config?: PersonWithRelationsOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.relationsA?.forEach((a) => a.setIds());

    this.relationsB?.forEach((a) => a.setIds());
  }
  assignFrom(
    config: PersonWithRelationsOptional,
    options?: AssignOptions,
  ): PersonWithRelationsTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.relationsA &&
      this.relationsAApplyFilter(optionsRequired.filter)
    ) {
      this.relationsA = config.relationsA?.map(
        (a) => new PersonRelationATracked(a, options),
      );
      if (optionsRequired.unassign) this.relationsAIsSet = false;
      else this.relationsAIsSet = true;
    }
    if (
      config.relationsB &&
      this.relationsBApplyFilter(optionsRequired.filter)
    ) {
      this.relationsB = config.relationsB?.map(
        (a) => new PersonRelationBTracked(a, options),
      );
      if (optionsRequired.unassign) this.relationsBIsSet = false;
      else this.relationsBIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PersonWithRelationsTrackedI {
    const cloned = {} as PersonWithRelationsTrackedI;
    if (
      this.relationsAIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.relationsAApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.relationsAIsSet = true;
      cloned.relationsA = this.relationsA
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.relationsAIsSet = false
    }
    if (
      this.relationsBIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.relationsBApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.relationsBIsSet = true;
      cloned.relationsB = this.relationsB
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.relationsBIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PersonWithRelationsTrackedI {
    if (!this.relationsAApplyFilter(filter)) this.relationsAIsSet = false;

    this.relationsA?.forEach((a) => a.unassignAll(filter));
    if (!this.relationsBApplyFilter(filter)) this.relationsBIsSet = false;

    this.relationsB?.forEach((a) => a.unassignAll(filter));
    return this;
  }
  relationsAApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonWithRelationsMeta.relationsA,
      PersonWithRelationsMeta,
      this.relationsA,
      this,
    );
  }
  relationsAIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.relationsAIsSet && this.relationsAApplyFilter(filter)) return true;

    return this.relationsA?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  relationsBApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonWithRelationsMeta.relationsB,
      PersonWithRelationsMeta,
      this.relationsB,
      this,
    );
  }
  relationsBIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.relationsBIsSet && this.relationsBApplyFilter(filter)) return true;

    return this.relationsB?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.relationsAIsSetDeep(filter)) return true;
    if (this.relationsBIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
